import { PaginationRequest } from './paginationRequest.model';

export class IdiomaRequest extends PaginationRequest {

  constructor() {
    super();
  }

}
